import React, { useEffect, useState } from 'react'
import get from 'lodash/get'

import WelcomeOwner from 'components/Owner/InitialAssessment/WelcomeOwner'
import { ProgressbarContainer } from 'pages/Common/container'
import { QuestionsContainer } from 'pages/Assessment/containers'
import UserCreationContainer from 'components/Common/UserCreationContainer'
import Navbar from 'components/Common/Navbar'
import ChevronLeftIcon from 'components/Common/SvgIcons/ChevronLeftIcon'
import LogoNavigationButton from 'layout/Layout/LayoutNavbar/LogoNavigationButton'

import { isActiveStep, showChevronLeftIcon, navigateTo } from 'utils/helper'
import { ACTIVE_STEP, FORM, initialAssessmentStepper, ROLES } from 'config'

import { StepperWrapper } from 'components/Common/StyledComponents/StepperWrapper'

import { isEmpty } from 'lodash'
import SmsSubscriptionNotification from 'components/NotificationPanel/SmsSubscriptionNotification'
import Loaders from 'components/Loaders'
import { CreateProfileContainer } from 'pages/Owner/container'
import SmsUnsubscribeNotification from 'components/NotificationPanel/SmsUnsubscribeNotification'

const InitialAssessment = ({
  steps,
  error,
  assessment,
  activeStep,
  onboardedAt,
  currentUser,
  activeQuestion,
  resetAssessment,
  setActiveStepAction,
  getUserProfileAction,
  isUpdateProfileLoading,
  updateUserProfileAction,
  updateProgressbarAction,
  inputFieldbgColorAction,
  addEditAssessmentAction,
  initializeOwnerStepperAction,
  getUserBusinessProfileAction,
  ownerOnBoardingCompletionAction,
  isLoadingAssessmentResponse,
}) => {
  const [moveToPreviousQuestion, setMoveToNextQuestion]: any = useState('')
  const [isLastQuestion, setIsLastQuestion] = useState(false)

  useEffect(() => {
    initializeOwnerStepperAction(initialAssessmentStepper)
    return () => resetAssessment()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    if (activeStep === 'Create Profile') {
      inputFieldbgColorAction('bg-white')
    } else {
      inputFieldbgColorAction('bg-grey-light')
    }
    // eslint-disable-next-line
  }, [activeStep])
  useEffect(() => {
    getUserProfileAction({ setForms: [FORM.PROFILE_FORM] })
    addEditAssessmentAction({ type: 'initial' })
  }, [getUserProfileAction, addEditAssessmentAction])

  useEffect(() => {
    if (currentUser?.id) {
      getUserBusinessProfileAction({ userId: currentUser?.id, setForms: [FORM.BUSINESS_PROFILE] })
      getUserProfileAction({ setForms: [FORM.PROFILE_FORM] })
    }
    // eslint-disable-next-line
  }, [getUserBusinessProfileAction, currentUser])

  useEffect(() => {
    if (assessment?.stepIndex > 1) {
      setActiveStepAction(steps[assessment.stepIndex]?.title)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessment?.stepIndex])

  const moveToNext = () => {
    const indexofActiveStep = steps.findIndex((step) => step?.title === activeStep)
    setActiveStepAction(steps[indexofActiveStep + 1]?.title)
  }

  const moveToNextTwo = () => {
    const indexofActiveStep = steps.findIndex((step) => step?.title === activeStep)
    setActiveStepAction(steps[indexofActiveStep + 2]?.title)
  }

  const handleBack = (step) => {
    if (step !== 'Questions') {
      setMoveToNextQuestion('')
      const indexofActiveStep = steps.findIndex((step) => step?.title === activeStep)
      setActiveStepAction(steps[indexofActiveStep - 1]?.title)
    } else {
      if (typeof moveToPreviousQuestion === 'string') {
        setMoveToNextQuestion(false)
      } else {
        setMoveToNextQuestion(!moveToPreviousQuestion)
      }
    }
  }
  const handleBackTwo = () => {
    const indexofActiveStep = steps.findIndex((step) => step?.title === activeStep)
    setActiveStepAction(steps[indexofActiveStep - 2]?.title)
  }
  useEffect(() => {
    if (isLastQuestion && !isLoadingAssessmentResponse && currentUser.isNewUser && !onboardedAt) {
      ownerOnBoardingCompletionAction()
    }
    if (isLastQuestion && !isLoadingAssessmentResponse && !currentUser.isNewUser && onboardedAt) {
      navigateTo(ROLES.BUSINESS_OWNER, 'dashboard')
    }
    // eslint-disable-next-line
  }, [isLastQuestion, isLoadingAssessmentResponse])

  return (
    <StepperWrapper>
      <Navbar
        leftContent={() => {
          return showChevronLeftIcon(activeStep, activeQuestion) ? (
            <div onClick={() => handleBack(activeStep)}>
              <ChevronLeftIcon />
            </div>
          ) : (
            <></>
          )
        }}
        centerContent={() => {
          return <LogoNavigationButton className="h-4/5" />
        }}
      />
      <UserCreationContainer
        width="max-w-[510px]"
        bgColor={`${
          activeStep === 'Questions' || activeStep === 'Terrific' ? 'bg-white' : 'bg-sky'
        }`}
      >
        <div
          className={`${activeStep && activeStep !== 'Welcome Owner' ? 'block' : 'hidden'} my-6`}
        >
          <ProgressbarContainer
            startingIndex={assessment?.progressBarIndex}
            totalSteps={get(assessment, 'totalSteps', 0) + 2}
            bgColorClass="bg-gradient-to-r from-[#8400F7] to-[#52B4F9]"
          />
        </div>
        {isUpdateProfileLoading ? (
          <div className="xs:w-[310px] sm:w-[510px] px-5">
            <Loaders loader="AssessmentLoader" />
          </div>
        ) : (
          <>
            {activeStep === ACTIVE_STEP.WELCOME_OWNER && (
              <div className={isActiveStep(activeStep, ACTIVE_STEP.WELCOME_OWNER)}>
                <WelcomeOwner onSubmit={moveToNext} firstName={currentUser.firstName} />
              </div>
            )}
            <div className="w-full">
              <div className={`${isActiveStep(activeStep, ACTIVE_STEP.CREATE_PROFILE)} mt-0`}>
                <CreateProfileContainer
                  moveToNext={moveToNext}
                  handleBack={() => handleBack(activeStep)}
                />
              </div>
              {activeStep === ACTIVE_STEP.SMS_SUBSCRIPTION && (
                <div className={isActiveStep(activeStep, ACTIVE_STEP.SMS_SUBSCRIPTION)}>
                  <SmsSubscriptionNotification
                    user={currentUser}
                    onSubmit={updateUserProfileAction}
                    moveToNext={moveToNext}
                    moveToNextTwo={moveToNextTwo}
                    isLoading={isUpdateProfileLoading}
                    isWelcomeScreen={true}
                    handleBack={() => handleBack(activeStep)}
                    progressBarAction={updateProgressbarAction}
                  />
                </div>
              )}
              {activeStep === ACTIVE_STEP.SMS_UNSUBSCRIBE_CONFIRMATION && (
                <div className={isActiveStep(activeStep, ACTIVE_STEP.SMS_UNSUBSCRIBE_CONFIRMATION)}>
                  <SmsUnsubscribeNotification
                    user={currentUser}
                    onSubmit={updateUserProfileAction}
                    moveToNext={moveToNext}
                    isLoading={isUpdateProfileLoading}
                    isWelcomeScreen={true}
                    handleBack={() => handleBack(activeStep)}
                    progressBarAction={updateProgressbarAction}
                  />
                </div>
              )}
              {(activeStep === ACTIVE_STEP.QUESTIONS || isEmpty(activeStep)) && (
                <div data-testid="QuestionsContainer">
                  <QuestionsContainer
                    userId={currentUser?.id}
                    assessmentType="initial"
                    onSubmit={() => {
                      setIsLastQuestion(true)
                    }}
                    handleBackTogggle={moveToPreviousQuestion}
                    isOverRideBack
                    moveBackOnFirstQuestion={() => handleBackTwo()}
                  />
                </div>
              )}
            </div>
          </>
        )}
      </UserCreationContainer>
    </StepperWrapper>
  )
}
export default InitialAssessment
